// types/forms.ts
import { z } from "zod";

// export const profileFormSchema = z.object({
//   userName: z
//     .string()
//     .min(2, "User Name must be at least 2 characters")
//     .max(50, "User Name must be less than 50 characters"),
//   userReadEmail: z
//     .string()
//     .min(1, "Email is required")
//     .email("Invalid email address")
//     .max(100, "Email must be less than 100 characters")
//     .refine(
//       (value) => value.toLowerCase() === value,
//       "Email must be lowercase"
//     ),
//   userPhone: z
//     .string()
//     .min(1, "Phone number is required")
//     .regex(
//       /^(\+\d{1,3}[-.]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
//       "Please enter a valid phone number"
//     )
//     .transform((val) => val.replace(/[-\s()]/g, "")),
//   userRole: z.enum(["Administrator", "Sales Manager", "Sales"], {
//     required_error: "Please select a role",
//     invalid_type_error: "Please select a valid role",
//   }),
// });

// export type ProfileFormData = z.infer<typeof profileFormSchema>;



export const UserFormSchema = z.object({
  userName: z
    .string()
    .min(2, "User Name must be at least 2 characters")
    .max(50, "User Name must be less than 50 characters"),
  userEmail: z
    .string()
    .min(1, "Email is required")
    .email("Invalid email address")
    .max(100, "Email must be less than 100 characters")
    .refine(
      (value) => value.toLowerCase() === value,
      "Email must be lowercase"
    ),
  userPhone: z
    .string()
    .min(1, "Phone number is required")
    .regex(
      /^(\+\d{1,3}[-.]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      "Please enter a valid phone number"
    )
    .transform((val) => val.replace(/[-\s()]/g, "")),
  role_uuid: z.string().min(1, "Role is required"),
  team_uuid: z.string().optional(),
  user_slug: z.string().optional(),
  designation: z.string().optional(),
  description: z.string().optional(),
  counselor_type: z.enum(["admission", "generic"]).optional().nullable(),
  expertise: z.string().optional(),
  leadNotifications: z.array(z.string()).default([]),
  notificationsPaused: z.enum(["yes", "no"]).default("no"),
  dailyEmailReports: z.array(z.string()).default([]),
});

export type UserFormData = z.infer<typeof UserFormSchema>;

// add Role validation
export const RoleFormSchema = z.object({
  roleName: z
    .string()
    .min(2, "Role Name must be at least 2 characters")
    .max(20, "Role Name must be less than 20 characters"),
  roleDescription: z.string().nullable(),
  pipeline: z.string().optional(),
  leadPermissions: z.array(z.string()).default([]),
  exportLeads: z.string().optional(),
  assignLeads: z.string().optional(),
  viewAllLeads: z.string().optional(),
  contactsPermissions: z.array(z.string()).default([]),
  trashPermissions: z.array(z.string()).default([]),
  dashboardPermissions: z.array(z.string()).default([]),
  reportsPermissions: z.array(z.string()).default([]),
  eventPermissions: z.array(z.string()).optional(),
  formManagement: z.string().optional(),
  userManagement: z.string().optional(),
});

export type RoleFormData = z.infer<typeof RoleFormSchema>;

// add Role validation
export const SignInWithOTPSchema = z.object({
  phone: z.string().length(10, "Enter a valid 10-digit mobile number"),
  otp: z.string().length(6, "Enter a valid 6-digit OTP").optional(),
});

export type otpFormData = z.infer<typeof SignInWithOTPSchema>;


export const ModuleFormSchema = z.object({
  module_name: z
    .string()
    
});

export type ModuleFormData = z.infer<typeof ModuleFormSchema>;